import React, { useState } from 'react';
import AnalyticsOverview from './components/AnalyticsOverview';
import MetricDetails from './components/MetricDetails';
import LeadInsights from './components/LeadInsights';
import './styles.css';

export default function AnalyticsReportsPage() {
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [reportMode, setReportMode] = useState(false);
  const [range, setRange] = useState("7");
  return <section className="cb-analytics-module">
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
      <div><div className="small text-primary fw-semibold">CHATBIZZ / INSIGHTS</div><h1 className="h3 mb-0">Analytics &amp; Reports</h1></div>
      {selectedMetric ? <button className="btn btn-outline-secondary btn-sm" onClick={() => setSelectedMetric(null)}>Back to overview</button> : <div className="btn-group btn-group-sm" role="group" aria-label="Analytics view"><button className={'btn ' + (!reportMode ? 'btn-primary' : 'btn-outline-primary')} onClick={() => setReportMode(false)}>Analytics</button><button className={'btn ' + (reportMode ? 'btn-primary' : 'btn-outline-primary')} onClick={() => setReportMode(true)}>Reports</button></div>}
    </div>
    {selectedMetric ? <MetricDetails metric={selectedMetric} range={range} onBack={() => setSelectedMetric(null)} /> : <AnalyticsOverview onMetricClick={setSelectedMetric} reportMode={reportMode} range={range} onRangeChange={setRange} />}
    {!selectedMetric && !reportMode && <LeadInsights />}
  </section>;
}
